// extracted by mini-css-extract-plugin
export default {"container":"hawk-main-toggle-container","title":"hawk-main-toggle-title","icon":"hawk-main-toggle-icon"};